import { message } from 'antd'

export const onSetDefaultProjection = ({ setDefaultProjection, onRefetch }) => {
  setDefaultProjection().then((response) =>
    onRefetch().then(() => message.success(response.payload.data.message, 8)),
  )
}
